import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from '../svgIcon';
import './styles.scss';

class Modal extends Component {
    static defaultProps = {
        visible: false,
        children: null,
        onOverlayClick: null,
        onClose: null,
        borderless: false,
    }

    static propTypes = {
        visible: PropTypes.bool,
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        onOverlayClick: PropTypes.func,
        onClose: PropTypes.func,
        borderless: PropTypes.bool,
    }

    constructor(props) {
        super(props);
        this.onModalClick = this.onModalClick.bind(this);
    }

   // eslint-disable-next-line class-methods-use-this
    onModalClick(event) {
        event.stopPropagation();
    }

    render() {
        const {
            visible,
            children,
            onClose,
            onOverlayClick,
            borderless,
        } = this.props;
        return visible ? (
            <div
                role="button"
                tabIndex={0}
                onClick={onOverlayClick}
                className="bs-overlay bs-overlay_modal"
            >
                <div className="bs-overlay__container">
                    <div
                        role="button"
                        tabIndex={0}
                        className={classNames(
                            'bs-modal',
                            { 'bs-modal_borderless': borderless },
                        )}
                        onClick={this.onModalClick}
                    >
                        {
                            onClose
                                ?
                                    <span
                                        role="button"
                                        tabIndex={0}
                                        onClick={onClose}
                                        className="bs-modal__closeBtn"
                                    >
                                        <Svg
                                            iconName="cross"
                                            size="Medium"
                                            className="bs-modal__closeIcon"
                                        />
                                    </span>
                                : null
                        }
                        <div className="bs-modal__canvas">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

export default Modal;



// WEBPACK FOOTER //
// /src/js/common/modal/Modal.jsx